import withTranslations from '../../../core/withTranslations'

export default withTranslations({
  locationText: 'common:location',
  locationPlaceholder: 'charity.locationForm.placeholder',
  errorSelectAddressText: 'forms.validation.errorSelectAddress',
  errorOnlyUSNotificationText: 'forms.validation.errorOnlyUSNotification',
  notifyWhenOutOfUSAvailableText:
    'charity.locationForm.notifyWhenOutOfUSAvailable',
  cancelText: 'common:cancel',
  saveText: 'common:save'
})



// WEBPACK FOOTER //
// ./src/services/mycharity/charity/withLocationFormTranslations.js